import { render, staticRenderFns } from "./Treaties.vue?vue&type=template&id=39be8b32&"
import script from "./Treaties.vue?vue&type=script&lang=js&"
export * from "./Treaties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports